import React from "react";
import HelpDeskHeader from "../components/Header/HelpDeskHeader";
import BiometricHeader from "../components/Header/BiometricHeader";
//import TopBarInfo from "components/TopbarInfo/TopBarInfo";
//import _analysisService from "modules/AnalysisService";
import { withRouter, Link } from "react-router-dom";
import { Layout, Tag, Spin, Alert } from "antd";
// import { routes } from "routes/Routes";
import _notification from 'modules/notification';
const key = "updatable";

const { Content } = Layout;

let myThis = "";
// Sprint 2 (Enterprise Application Shell): swapped onto the same ent-admin-shell/ent-admin-body
// flex shell AdminLayout.jsx already uses, replacing the generic calc(100vh - 95px) magic-number
// height. No sidebar is added here — this portal has never had one.
class BiometricLayout extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isPageLoaded: false,
            showBorderMargin: false
        };
    }
    componentDidMount() {
        //console.log("Admin layout");
    }

    render() {
        let isShowSpinner = this.state.isPageLoaded;
        let showAnalysisRunning = this.state.showAnalysisRunning;

        const currentYear = new Date().getFullYear();
        const previousYear = currentYear - 1;


        return (
            <div className="admin-home ent-admin-shell">
                <BiometricHeader />
                <Layout className="ent-admin-body">
                    <Layout>
                        <Content
                            className={
                                this.state.showBorderMargin
                                    ? "container-fluid align-items-center align-items-stretch pl-0 "
                                    : "container-fluid align-items-center align-items-stretch "
                            }>
                            <div className="ent-admin-content">
                                {React.cloneElement(this.props.children, { isPageLoaded: this.state.isAnalysisRunning })}
                                {isShowSpinner == true &&
                                    <Spin size="large" tip="Fetching page data is in process"><Alert
                                        message="Loading please wait..."
                                        description="Fetching page data, please wait....."
                                        type="warning"
                                    /></Spin>}
                            </div>
                        </Content>
                        <div className="ent-app-footer">
                            Copyright {previousYear}-{currentYear}. All Rights Reserved.
                        </div>
                    </Layout>
                </Layout>
            </div>
        );
    }
}

export default withRouter(BiometricLayout);
